// device-info.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceInfoService {
  getDeviceInfo() {
    const ua = navigator.userAgent;
    return {
      userAgent: ua,
      platform: navigator.platform,
      language: navigator.language,
      screen: `${screen.width}x${screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      // Un fingerprint más robusto (opcional)
      fingerprint: this.generateFingerprint(ua)
    };
  }

  private generateFingerprint(ua: string): string {
    const raw = `${ua}-${navigator.platform}-${screen.width}x${screen.height}-${navigator.language}`;
    // hash simple; para algo serio usa una lib como fingerprintjs
    let hash = 0;
    for (let i = 0; i < raw.length; i++) {
      hash = (hash << 5) - hash + raw.charCodeAt(i);
      hash |= 0;
    }
    return hash.toString(16);
  }
}